import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../../../assets/images/logo.svg";
import right_icon from "../../../../assets/images/docTypeIcons/right-direc.svg";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="pt-4 background-secondary">
      <nav className="mx-3 mx-md-5 d-flex justify-content-between align-items-center py-3 px-4 rounded-pill bg-white position-relative">
        {/* Logo */}
        <img src={logo} alt="logo" className="logo-footer" />

        <button
          className={`d-md-none border-0 bg-transparent toggler-btn ${
            isMenuOpen ? "open" : ""
          }`}
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          <span className="custom-toggler-icon">
            <div></div>
          </span>
        </button>

        {/* Nav Menu */}
        <ul
          className={`nav-list list-unstyled mb-0 ${
            isMenuOpen ? "show" : ""
          } d-md-flex align-items-center gap-md-5`}
        >
          <li
            onClick={() => scrollToSection("features")}
            className="cursor-pointer"
          >
            Features
          </li>
          <li
            onClick={() => scrollToSection("download")}
            className="cursor-pointer"
          >
            Download
          </li>
          <li
            onClick={() => scrollToSection("why-doxbox")}
            className="cursor-pointer"
          >
            Why DOXBOX!
          </li>
          <li>
            <button
              onClick={() => {
                setIsMenuOpen(false);
                navigate("/login");
              }}
              className="d-flex justify-content-between align-items-center px-3 py-2 border-0 text-white fw-60 background-primary rounded-3"
            >
              Login
              <img src={right_icon} className="ps-2" alt="right-icon" />
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
